/**
 * Based on KawaseLightStreak shader, cobbled together mostly from Castor3D-engine's c++/Vulcan implementation: https://github.com/DragonJoker/Castor3D/tree/development/source/Plugins/PostEffects/LightStreaksPostEffect
 * And peeks at Unity's implementation: https://github.com/nobnak/KawaseLightStreakUnity/tree/master/Assets/Packages/KawaseLightStreak/Materials
 * Deep-dive: https://chrisoat.com/papers/Oat-SteerableStreakFilter.pdf
 */
import { EffectPass } from 'postprocessing';
import { Camera, LinearFilter, LinearSRGBColorSpace, PerspectiveCamera, RenderTargetOptions, Scene, Vector2 } from 'three';
import { KawaseLightStreakProps } from '../../components/three/KawaseLightStreak';
import { KawaseHighPassEffect, KawaseStreaksEffect } from './postprocessing/KawaseLightStreakPostProcessEffects';

// TODO is passing of React props working?
// let _uThreshold: KawaseLightStreakProps['threshold']; // outside of class
// _uThreshold = threshold; // in constructor()
// this.uniforms.get('uThreshold')!.value = _uThreshold; // in update() - at least in an Effect

export const getKawaseHighPassEffectPass = ({
    camera,
    threshold,
    opacity,
}: {
    camera: Camera;
    threshold: KawaseLightStreakProps['threshold'];
    opacity: KawaseLightStreakProps['threshold'];
}) => {
    const k_highPass = new KawaseHighPassEffect(threshold, opacity);
    const effectPass = new EffectPass(camera, k_highPass);
    effectPass.needsSwap = false; // should be false?
    effectPass.renderToScreen = false; // should be false?

    return effectPass;
};

export const getKawaseStreaksEffectPass = ({
    scene,
    camera,
    width,
    height,
    attenuation,
    blurPasses,
    enabled,
}: {
    scene: Scene;
    camera: PerspectiveCamera;
    width: number;
    height: number;
    attenuation: KawaseLightStreakProps['attenuation'];
    blurPasses: KawaseLightStreakProps['blurPasses'];
    enabled: boolean;
}) => {
    /* WARN lower value that is divided = smoother image. not sure what exactly that means, it should be 1? What about performance? */
    const pixelSize = new Vector2(0.5 / width, 0.5 / height);

    /* Either directions element is mirrored in shader, resulting in star with 4 branches */
    const directions = [new Vector2(1, 1), new Vector2(1, -1)];

    const k_streaks = new KawaseStreaksEffect({
        scene,
        camera,
        width,
        height,
        resolutionScale: 0.5,
        attenuation,
        blurPasses,
        pixelSize,
        directions,
        enabled,
    });

    const effectPass = new EffectPass(camera, k_streaks);
    effectPass.renderToScreen = false; // should be false?

    return effectPass;
};

/** Local */

export const kawasePassRenderTargetOptions: RenderTargetOptions = {
    depthBuffer: false,
    generateMipmaps: false,
    minFilter: LinearFilter,
    magFilter: LinearFilter,
    colorSpace: LinearSRGBColorSpace,
};
